import React, { useState } from "react";
import JobTypeListing from "../listing";
import DedicatedFilters from "./filters";
import { TypeStatsSection } from "../components/type-stats-section";

export default function DedicatedJobs() {

  const [filters,setFilters]=useState({})
  

  return (
    <JobTypeListing 
      type="dedicated" 
      title="Dedicated Jobs" 
      filters={DedicatedFilters}
     onFiltersChange={setFilters}
      renderContent={() => (
        <TypeStatsSection jobType="dedicated" filters={filters} />
      )}
    />
  );
}
